import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { TextField } from '../../../../components/fields';
import { required, minLength8, matchPasswords, password } from '../../../../utilities/validation';
import messages from '../../../../text/messages';
import { FormattedMessage } from 'react-intl';

class ChangePassword extends React.Component {
    render() {
        const { handleSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <Field
                        name="password"
                        component={TextField}
                        validate={[required, minLength8, ...password]}
                        type="password"
                        placeholder={messages.password}
                    />
                </div>
                <div className="form-group">
                    <Field
                        name="password2"
                        component={TextField}
                        validate={[required, minLength8, ...password]}
                        type="password"
                        placeholder={messages.retypePassword}
                    />
                </div>

                <div className="form-group">
                    <button type="submit" className="btn btn-success btn-block" disabled={submitting}>
                        <FormattedMessage {...messages.update} />
                    </button>
                </div>
            </form>
        );
    }
}

ChangePassword.defaultProps = {
    handleSubmit: undefined,
    submitting: false
};

ChangePassword.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

export default reduxForm({ form: 'Login', destroyOnUnmount: true, validate: matchPasswords })(ChangePassword);



// WEBPACK FOOTER //
// ./src/pages/account/forms/changePassword/index.jsx